import { useEffect, useState } from 'react';

/**
 * Whether the browser believes it is online.
 *
 * `navigator.onLine` is only a hint — it reports the presence of a network
 * interface, not reachability — so this drives the offline banner rather than
 * gating requests. A failed request is still the authoritative signal.
 */
export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine,
  );

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);

    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);

    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return online;
}
